import { apiEndpoints } from "@/services/api/api";
import {
  VerifyCodeFormActionResponse,
  VerifyCodeFormData,
} from "../types/verifyCodeTypes";

export async function VerifyCodeAction({ request }: { request: Request }) {
  const formData = await request.formData();
  const code = formData.get("code") as string;
  const email = formData.get("email") as string;

  const verifyCodeData = {
    code: code,
    email: email,
  } satisfies VerifyCodeFormData;
  // TO DO Result'a type verilecek. Error handling yapılacak.
  const result = await apiEndpoints.sendVerifyCodeAndEmail(verifyCodeData);

  if (result.success) {
    return {
      verifyCodeData,
      shouldRedirect: true,
    } satisfies VerifyCodeFormActionResponse;
  }
}
